import TextField from '@mui/material/TextField';

// ----------------------------------------------------------------------

type HeadFilterTextFieldProps = {
  filterValue: string;
  setFilterValue: (value: string) => void;
  selectedColumn: { label?: string } | null;
  t: (key: string) => string;
};

// ----------------------------------------------------------------------

export function HeadFilterTextField({
  filterValue,
  setFilterValue,
  selectedColumn,
  t,
}: HeadFilterTextFieldProps) {
  return (
    <TextField
      fullWidth
      variant="outlined"
      size="small"
      placeholder={`${t('FILTER')} ${selectedColumn?.label}`}
      value={filterValue}
      onChange={(e) => {
        const newValue = e.target.value.trim();
        if (newValue.length === 0) {
          setFilterValue('');
          return;
        }
        setFilterValue(e.target.value);
      }}
    />
  );
}
